// UTM / attribution capture + persistence.
// Captures on first visit, persists in sessionStorage, and can be
// serialized into any outbound URL (e.g. GHL calendar iframe).

const KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "fbclid",
  "gclid",
  "referrer",
];

const STORAGE_KEY = "sba_attribution_v1";

export function captureAttribution() {
  if (typeof window === "undefined") return {};
  try {
    const existing = readAttribution();
    const url = new URL(window.location.href);
    const captured = { ...existing };
    let changed = false;
    for (const k of KEYS) {
      if (k === "referrer") continue;
      const v = url.searchParams.get(k);
      if (v && !captured[k]) {
        captured[k] = v;
        changed = true;
      }
    }
    if (!captured.referrer && document.referrer) {
      captured.referrer = document.referrer;
      changed = true;
    }
    if (!captured.landing_url) {
      captured.landing_url = window.location.href;
      changed = true;
    }
    if (!captured.first_seen_at) {
      captured.first_seen_at = new Date().toISOString();
      changed = true;
    }
    if (changed) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(captured));
    }
    return captured;
  } catch (e) {
    return {};
  }
}

export function readAttribution() {
  if (typeof window === "undefined") return {};
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
}

export function appendAttributionToUrl(baseUrl, extra = {}) {
  if (!baseUrl) return baseUrl;
  try {
    const url = new URL(baseUrl);
    const attr = { ...readAttribution(), ...extra };
    for (const [k, v] of Object.entries(attr)) {
      if (v == null || v === "") continue;
      // Skip fields the calendar host wouldn't recognize
      if (["landing_url", "first_seen_at"].includes(k)) continue;
      url.searchParams.set(k, String(v));
    }
    return url.toString();
  } catch (e) {
    return baseUrl;
  }
}
